module.exports = __webpack_public_path__ + "static/media/campaignTracking-01.5dbc21a6.png";